<mat-grid-list cols="6" rows="4" fxLayout="row" rowHeight="fit" gutterSize="0.5em" fxFill>
  <mat-grid-tile class="pad" fxFlex="20" *ngFor="let sample of samples; index as i;" (click)="onClick(i)"
  [class.loading]="!samples[i]?.isLoaded" [class.playing]="samples[i]?.isPlaying">
    <mat-icon >play_arrow</mat-icon>
    <mat-grid-tile-footer>{{sample.name}}</mat-grid-tile-footer>
  </mat-grid-tile>
</mat-grid-list>